module.exports = __webpack_public_path__ + "img/APPR.fb2b2fbb.svg";